import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("navrang_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("navrang_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, qty = 1) => {
    setItems((prev) => {
      const key = `${product.id}-${size || ""}`;
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      return [...prev, {
        key, product_id: product.id, name: product.name, price: product.price,
        image: (product.images && product.images[0]) || "", size: size || null, qty,
      }];
    });
  };

  const updateQty = (key, qty) => setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty: Math.max(1, qty) } : i)));
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}
